export const programatik = {
  title: 'Data & Display & Programatik',
  titleEN: 'Data & Display & Programatic',
  description: '<span style=\'font-weight: 600;\'>Preferred Deal(PD)</span> <br/>Display yayınlar için Ad Manager zerinden diğer DSP’lerle deal yapılabiliyor. Outstream için ise Teads platformu zerinden diğer DSP’lerle deal yapılabiliyor. PD için DSP platformuyla SSP platformunun aynı olması şartı bulunmuyor.<br /> <br /><span style=\'font-weight: 600;\'>Programmatic Guaranteed(PG)</span> <br/> PG dealları ile Publisher-Served Custom Creativeler ile programatik projeler gerçekleştirebiliyoruz. PG dealı yapılabilmesi için mşteri tarafında kullanılan DSP platformlarının DV360 gibi Google platformu olması gerekmektedir',
  descriptionEN: '<span style=\'font-weight: 600;\'>Preferred Deal(PD)</span> <br/> For display advertising, deals can be made with other DSPs through Ad Manager. For Outstream, deals can be made with other DSPs through the Teads platform. It\'s not necessary for the DSP platform to be the same as the SSP platform for Programmatic Direct.<br /> <br /><span style=\'font-weight: 600;\'>Programmatic Guaranteed(PG)</span> <br/>With PG (Programmatic Guaranteed) deals, we can execute programmatic projects with Publisher-Served Custom Creatives. To make a PG deal, the DSP platform used by the client needs to be a Google platform such as DV360. ',
  tabs: [
    {
      id: 1,
      title: 'Programatik',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/60d9c3a968133502e0f34b8db73816b2654b46e06a1f0efc08b968759e8cd99e.png',
          url: 'https://onedio.com/haber/onedio-com-programatik-proje-katalogu-886611',
          name: 'Programatik Proje Kataloğu',
        }
      ]
    },
    {
      id: 2,
      title: 'Data',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/691680a17a43ca992edc1a5b393211bb904534f480bbf8a08072fe0791a963c0.png',
          modalTitle: 'Programatik Data',
          modal: 'image'
        }
      ]
    },
    {
      id: 3,
      title: 'Display Alanlar',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/16a034c17c53af28518ff946aa722a044d535d811d5441afb8fb5f0890d61d07.png',
          url: 'https://onedio.com/haber/en-sevilen-unluler-arkadasimiz-olsa-onlarla-neler-yapacagimizi-tek-tek-bulup-analiz-ettik-1118390?google_preview=Vo_dV5lDBYMYlvXMnQYwlpGCpQaIAYCAgOCc95Gv-QE&iu=21814681&gdfp_req=1&lineItemId=6192186914&creativeId=138418378185',
          name: 'Vodafone 320x480'
        },
        {
          id: 2,
          image: 'https://srv-cdn.onedio.com/store/828e77faed14e750e4029fb2d3b6de7249fb4e08de8caa62f2e002cdc4b11a3a.png',
          url: 'https://onedio.com/?google_preview=r9NHCdvBNHMY9IrCoAYw9Kb3pwaIAYCAgOCq3IuwpwE&iu=21814681&gdfp_req=1&lineItemId=5903309888&creativeId=138379347692',
          name: 'Heinz Mobile MH'
        },
        {
          id: 3,
          image: 'https://srv-cdn.onedio.com/store/28f6c4f2813abc3e0dbb66bd0edd6198cb6858559c22d3837f23c605988bd6f2.png',
          url: 'https://onedio.com/haber/oyku-serter-in-kismetse-olur-dan-aldigi-maas-duyanlari-hayrina-mi-calisiyorsun-dedirtti-1133966?google_preview=v-joRCRYMHMYzKTXxAYwzMCMzAaIAYCAgJC89pPwYg&iu=21814681&gdfp_req=1&lineItemId=5832197755&creativeId=138370783760',
          name: 'Netflix - Arcane 300x600'
        },
        {
          id: 4,
          image: 'https://srv-cdn.onedio.com/store/3a2f2fb1d22a5ed89da7463ad7fad1c9ca01a6a5317a61c2cfbd09d541bc3075.png',
          url: 'https://onedio.com/?google_preview=_YtHK6rFWeUY-KPXxAYw-L-MzAaIAYCAgJC89qOtcQ&iu=21814681&gdfp_req=1&lineItemId=6145438765&creativeId=138410514590',
          name: 'Pantene Desktop MH'
        },
        {
          id: 5,
          image: 'https://srv-cdn.onedio.com/store/e155e22d198fb58e41cff66aba6892bbc3b3b5c24dcda2a4abcd5e25ddef1bb5.png',
          url: 'https://onedio.com/?google_preview=Mf6yH6EV33UYt6PXxAYwt7-MzAaIAYCAgJC89uPIPg&iu=21814681&gdfp_req=1&lineItemId=6237951998&creativeId=138425198674',
          name: 'Pandora Pageskin'
        }
      ]
    },
    {
      id: 4,
      title: 'Social Media Distribution',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/28286b6225e58d8dcb3a83bced4aacdfcd109369e81fba660c41e7bae96322ca.png',
          name: 'Instagram Post Story Örneği',
          modalTitle: 'Instagram Post Story',
          modal: 'image'
        }
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Programmatic',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/60d9c3a968133502e0f34b8db73816b2654b46e06a1f0efc08b968759e8cd99e.png',
          url: 'https://onedio.com/haber/onedio-com-programatik-proje-katalogu-886611',
          name: 'Programmatic Project Catalog',
        }
      ]
    },
    {
      id: 2,
      title: 'Data',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/3909d52d9a083452e096139657cdeee35124df4f79679551cec65858ae9ae24a.png',
          modalTitle: 'Programmatic Data',
          modal: 'image'
        }
      ]
    },
    {
      id: 3,
      title: 'Display Fields',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/16a034c17c53af28518ff946aa722a044d535d811d5441afb8fb5f0890d61d07.png',
          url: 'https://onedio.com/haber/en-sevilen-unluler-arkadasimiz-olsa-onlarla-neler-yapacagimizi-tek-tek-bulup-analiz-ettik-1118390?google_preview=Vo_dV5lDBYMYlvXMnQYwlpGCpQaIAYCAgOCc95Gv-QE&iu=21814681&gdfp_req=1&lineItemId=6192186914&creativeId=138418378185',
          name: 'Vodafone 320x480'
        },
        {
          id: 2,
          image: 'https://srv-cdn.onedio.com/store/828e77faed14e750e4029fb2d3b6de7249fb4e08de8caa62f2e002cdc4b11a3a.png',
          url: 'https://onedio.com/?google_preview=r9NHCdvBNHMY9IrCoAYw9Kb3pwaIAYCAgOCq3IuwpwE&iu=21814681&gdfp_req=1&lineItemId=5903309888&creativeId=138379347692',
          name: 'Heinz Mobile MH'
        },
        {
          id: 3,
          image: 'https://srv-cdn.onedio.com/store/28f6c4f2813abc3e0dbb66bd0edd6198cb6858559c22d3837f23c605988bd6f2.png',
          url: 'https://onedio.com/haber/oyku-serter-in-kismetse-olur-dan-aldigi-maas-duyanlari-hayrina-mi-calisiyorsun-dedirtti-1133966?google_preview=v-joRCRYMHMYzKTXxAYwzMCMzAaIAYCAgJC89pPwYg&iu=21814681&gdfp_req=1&lineItemId=5832197755&creativeId=138370783760',
          name: 'Netflix - Arcane 300x600'
        },
        {
          id: 4,
          image: 'https://srv-cdn.onedio.com/store/3a2f2fb1d22a5ed89da7463ad7fad1c9ca01a6a5317a61c2cfbd09d541bc3075.png',
          url: 'https://onedio.com/?google_preview=_YtHK6rFWeUY-KPXxAYw-L-MzAaIAYCAgJC89qOtcQ&iu=21814681&gdfp_req=1&lineItemId=6145438765&creativeId=138410514590',
          name: 'Pantene Desktop MH'
        },
        {
          id: 5,
          image: 'https://srv-cdn.onedio.com/store/e155e22d198fb58e41cff66aba6892bbc3b3b5c24dcda2a4abcd5e25ddef1bb5.png',
          url: 'https://onedio.com/?google_preview=Mf6yH6EV33UYt6PXxAYwt7-MzAaIAYCAgJC89uPIPg&iu=21814681&gdfp_req=1&lineItemId=6237951998&creativeId=138425198674',
          name: 'Pandora Pageskin'
        }
      ]
    },
    {
      id: 4,
      title: 'Social Media Distribution',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/28286b6225e58d8dcb3a83bced4aacdfcd109369e81fba660c41e7bae96322ca.png',
          name: 'Instagram Post Story Example',
          modalTitle: 'Instagram Post Story',
          modal: 'image'
        }
      ],
    }
  ]
}
